import { chipClasses } from '@mui/material';
import { Theme } from '@routific/hive';

export const DriverChipStyles = {
  height: Theme.Spacing.xlSpacing,
  padding: Theme.Spacing.xsSpacing,
  borderRadius: Theme.BorderRadius.lgBorderRadius,
  backgroundColor: Theme.Colors.gray0,
  borderColor: Theme.Colors.gray4,
  borderWidth: '1px',
  borderStyle: 'solid',
  [`& .${chipClasses.label}`]: {
    paddingLeft: '0px',
  },
  [`& .${chipClasses.deleteIcon}`]: {
    marginRight: '0px',
  },
};
